// import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
// import CheckIcon from "@mui/icons-material/Check";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import LockOpenIcon from "@mui/icons-material/LockOpen";

// const OrdersActionsBar = ({
//   type,
//   isCheckBoxSelection,
//   selectedJobIds,
//   tooltipMessage,
//   isSubmitting,
//   isSubmittingMarkAsCompleted,
//   handleOpenAssignPickerDialog,
//   handleOpenReleaseOrdersDialog,
//   handleOpenMarkAsCompletedDialog,
// }) => {
//   return (
//     <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//       {isCheckBoxSelection && (
//         <Tooltip
//           title={tooltipMessage}
//           placement="bottom-end"
//           slotProps={{
//             popper: {
//               modifiers: [
//                 {
//                   name: "offset",
//                   options: {
//                     offset: [0, -20],
//                   },
//                 },
//               ],
//             },
//           }}
//           arrow
//           disableHoverListener={selectedJobIds.length > 0 || isSubmitting}
//         >
//           <span>
//             <Button
//               variant="contained"
//               size="medium"
//               startIcon={
//                 type === "in-queue" ? <PersonAddIcon /> : <LockOpenIcon />
//               }
//               onClick={
//                 type === "in-queue"
//                   ? handleOpenAssignPickerDialog
//                   : handleOpenReleaseOrdersDialog
//               }
//               sx={{ mb: 2, textTransform: "none" }}
//               disabled={selectedJobIds.length === 0 || isSubmitting}
//             >
//               {isSubmitting
//                 ? "Please wait..."
//                 : type === "in-queue"
//                 ? "Assign Picker"
//                 : `Release Order${selectedJobIds.length === 1 ? "" : "s"}`}
//               {isSubmitting && (
//                 <CircularProgress size={24} sx={{ marginLeft: "16px" }} />
//               )}
//             </Button>
//           </span>
//         </Tooltip>
//       )}
//       {(type === "in-queue" || type === "delay-picking" || type === "git") && (
//         <Tooltip
//           title={
//             isSubmitting
//               ? "Please wait..."
//               : `Select at least one order to ${
//                   type === "in-queue"
//                     ? "mark as completed"
//                     : "release and assign to picker"
//                 } `
//           }
//           placement="bottom-end"
//           slotProps={{
//             popper: {
//               modifiers: [
//                 {
//                   name: "offset",
//                   options: {
//                     offset: [0, -20],
//                   },
//                 },
//               ],
//             },
//           }}
//           arrow
//           disableHoverListener={
//             selectedJobIds.length > 0 || isSubmittingMarkAsCompleted
//           }
//         >
//           <span>
//             <Button
//               variant="outlined"
//               size="medium"
//               color={type === "in-queue" ? "success" : "primary"}
//               startIcon={<CheckIcon />}
//               onClick={
//                 type === "in-queue"
//                   ? handleOpenMarkAsCompletedDialog
//                   : handleOpenAssignPickerDialog
//               }
//               sx={{ mb: 2, ml: 2, textTransform: "none" }}
//               disabled={
//                 selectedJobIds.length === 0 ||
//                 isSubmittingMarkAsCompleted ||
//                 isSubmitting
//               }
//             >
//               {type === "in-queue"
//                 ? "Mark as Completed"
//                 : `Release Order${
//                     selectedJobIds.length > 1 ? "s" : ""
//                   } and Assign Picker`}
//             </Button>
//           </span>
//         </Tooltip>
//       )}
//     </Box>
//   );
// };

// export default OrdersActionsBar;



// *************************************************************************************************

import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const OrdersActionsBar = ({
  type,
  isCheckBoxSelection,
  selectedJobIds,
  tooltipMessage,
  isSubmitting,
  isSubmittingMarkAsCompleted,
  handleOpenAssignPickerDialog,
  handleOpenReleaseOrdersDialog,
  handleOpenMarkAsCompletedDialog,
  // New permission props
  allowAssignPicker = 1,
  allowMarkAsComplete = 1,
  allowReleaseOrderAndAssignOrder = 1,
  allowReleaseOrders = 1,
}) => {
  // Determine if buttons should be shown based on permissions
  const showAssignPickerButton = type === "in-queue" && allowAssignPicker === 1;
  const showReleaseOrdersButton = (type === "delay-picking" || type === "git") && allowReleaseOrders === 1;
  const showMarkAsCompletedButton = type === "in-queue" && allowMarkAsComplete === 1;
  const showReleaseAndAssignButton = (type === "delay-picking" || type === "git") && allowReleaseOrderAndAssignOrder === 1;

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      {/* First Button - Assign Picker or Release Orders */}
      {isCheckBoxSelection && (showAssignPickerButton || showReleaseOrdersButton) && (
        <Tooltip
          title={tooltipMessage}
          placement="bottom-end"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -20],
                  },
                },
              ],
            },
          }}
          arrow
          disableHoverListener={selectedJobIds.length > 0 || isSubmitting}
        >
          <span>
            <Button
              variant="contained"
              size="medium"
              startIcon={
                type === "in-queue" ? <PersonAddIcon /> : <LockOpenIcon />
              }
              onClick={
                type === "in-queue"
                  ? handleOpenAssignPickerDialog
                  : handleOpenReleaseOrdersDialog
              }
              sx={{ mb: 2, textTransform: "none" }}
              disabled={selectedJobIds.length === 0 || isSubmitting}
            >
              {isSubmitting
                ? "Please wait..."
                : type === "in-queue"
                ? "Assign Picker"
                : `Release Order${selectedJobIds.length === 1 ? "" : "s"}`}
              {isSubmitting && (
                <CircularProgress size={24} sx={{ marginLeft: "16px" }} />
              )}
            </Button>
          </span>
        </Tooltip>
      )}

      {/* Second Button - Mark as Completed OR Release and Assign Picker */}
      {(showMarkAsCompletedButton || showReleaseAndAssignButton) && (
        <Tooltip
          title={
            isSubmitting
              ? "Please wait..."
              : `Select at least one order to ${
                  type === "in-queue"
                    ? "mark as completed"
                    : "release and assign to picker"
                } `
          }
          placement="bottom-end"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -20],
                  },
                },
              ],
            },
          }}
          arrow
          disableHoverListener={
            selectedJobIds.length > 0 || isSubmittingMarkAsCompleted
          }
        >
          <span>
            <Button
              variant="outlined"
              size="medium"
              color={type === "in-queue" ? "success" : "primary"}
              startIcon={<CheckIcon />}
              onClick={
                type === "in-queue"
                  ? handleOpenMarkAsCompletedDialog
                  : handleOpenAssignPickerDialog
              }
              sx={{ mb: 2, ml: 2, textTransform: "none" }}
              disabled={
                selectedJobIds.length === 0 ||
                isSubmittingMarkAsCompleted ||
                isSubmitting
              }
            >
              {type === "in-queue"
                ? "Mark as Completed"
                : `Release Order${
                    selectedJobIds.length > 1 ? "s" : ""
                  } and Assign Picker`}
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default OrdersActionsBar;
